export class ICESFilter {
    constructor(
        public ICES: string,
        public Year: number,
        public Factory: string[] = []
    ) {}
}